import { FC } from 'react';
import { Icon, Icons } from '@silverfort/sf-components';
import { bigNumberToText } from '../utils';
import { useDashboardContext } from './DashboardContext';

interface IdentityMetricProps {
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    value: number;
    label: string;
}

const IdentityMetric: FC<IdentityMetricProps> = ({ icon, value, label }) => (
    <div className="flex gap-3">
        <Icon icon={icon} size={24} className="text-opacity-60 pt-[0.5vh]" />
        <div className="flex flex-col gap-[0.4vh]">
            <span className="font-medium text-[2.2vh] font-sf-poppins">{bigNumberToText(value)}</span>
            <span className="font-normal text-[1.6vh] font-['Bitter']">{label}</span>
        </div>
    </div>
);

const IdentitiesMetrics: FC = () => {
    const { systemStatistics } = useDashboardContext();

    return (
        <div className="flex flex-col justify-center gap-[8vh] px-[2vw] text-sf-white">
            <IdentityMetric icon={Icons.User} value={systemStatistics.users} label={'Accounts'} />
            <IdentityMetric
                icon={Icons.Crown}
                value={systemStatistics.totalPrivilegedAccounts}
                label={'Privileged Accounts'}
            />
            <IdentityMetric
                icon={Icons.ServiceAccountRobot}
                value={systemStatistics.serviceAccounts}
                label={'Non-Human Identities'}
            />
        </div>
    );
};

export default IdentitiesMetrics;
